import React from "react";

const TwoArrowUp = ({ size = 12, color = "none", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 8 9"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.61335 0.654769L0.133786 3.79013C0.0443536 3.89174 -0.00345473 4.02439 0.000194327 4.16081C0.00384338 4.29722 0.0586726 4.42703 0.153404 4.52352C0.248136 4.62002 0.375568 4.67587 0.50949 4.67959C0.643411 4.6833 0.773639 4.63461 0.873389 4.54351L3.98992 1.73556L7.10644 4.54351C7.20619 4.63461 7.33642 4.6833 7.47034 4.67959C7.60426 4.67587 7.7317 4.62002 7.82643 4.52352C7.92116 4.42703 7.97599 4.29722 7.97964 4.16081C7.98329 4.02439 7.93548 3.89174 7.84605 3.79013L4.36648 0.654769C4.26246 0.548809 4.12619 0.497948 3.98992 0.500068C3.92019 0.498935 3.85094 0.512039 3.78627 0.53861C3.72159 0.56518 3.6628 0.604677 3.61335 0.654769ZM7.84709 8.3443C8.05097 8.13662 8.05097 7.7986 7.84709 7.59092L4.36752 4.45556C4.2635 4.3496 4.12723 4.29874 3.99096 4.30086C3.92118 4.29939 3.85184 4.31234 3.78712 4.33893C3.7224 4.36552 3.66364 4.4052 3.61439 4.45556L0.133787 7.58986C0.0443538 7.69147 -0.00345456 7.82412 0.000194493 7.96054C0.00384355 8.09695 0.0586727 8.22676 0.153405 8.32325C0.248137 8.41975 0.375568 8.4756 0.50949 8.47932C0.643411 8.48303 0.77364 8.43434 0.873389 8.34324L3.98992 5.53529L7.10644 8.34324C7.20453 8.44341 7.33766 8.4998 7.47655 8.5C7.61544 8.5002 7.74873 8.44419 7.84709 8.3443Z"
      fill={color}
    />
  </svg>
);

export default TwoArrowUp;
